import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

const StatusBar = ({ statusBarHeight = 0, color = 'transparent' }) => {
    return <div className={styles.wrap} style={{ height: statusBarHeight, backgroundColor: color }} />;
};

StatusBar.propTypes = {
    statusBarHeight: PropTypes.number,
    color: PropTypes.string,
};

export default StatusBar;
